// src/components/Footer.jsx
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-indigo-800 text-white py-6 mt-10">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        <p className="text-sm mb-2 md:mb-0">© {new Date().getFullYear()} EmpowerHer. All rights reserved.</p>
        <div className="flex space-x-4">
          <a href="/about" className="text-sm hover:underline">About</a>
          <a href="/contact" className="text-sm hover:underline">Contact</a>
          <a href="/faq" className="text-sm hover:underline">FAQs</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
